<template>
    <el-dialog
        title="新建标签"
        :visible="true"
        width="300px"
        :close-on-click-modal="false"
        :before-close="dialogBeforeClose"
        class="add-label-dialog-performance"
    >
        <div class="label-type"><span>请选择要保存的标签类型</span></div>
        <el-form ref="form" :model="form" :rules="formRules">
            <el-form-item prop="labelType">
                <el-checkbox-group v-model="form.labelType" class="label-group">
                    <el-checkbox :label="conditionList" name="conditionList"
                        >查询条件</el-checkbox
                    >
                    <el-checkbox :label="columnList" name="columnList"
                        >列配置</el-checkbox
                    >
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="标签名称:" label-width="85px" prop="tabName">
                <el-input
                    v-model="form.tabName"
                    placeholder="必填"
                    maxlength="255"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="dialogBeforeClose">取 消</el-button>
            <el-button
                type="primary"
                :loading="btnLoading"
                @click="handleSubmit"
                >确 定</el-button
            >
        </div>
    </el-dialog>
</template>

<script>
import { tabAdd } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    data () {
        return {
            btnLoading: false,
            dialogVisible: false,
            form: {
                labelType: [],
                tabName: ''
            },
            formRules: {
                labelType: [
                    { type: 'array', required: true, message: '请至少选择一种标签类型', trigger: 'change' }
                ],
                tabName: [
                    { required: true, message: '请填写标签名称', trigger: 'blur' }
                ]
            }
        };
    },
    props: {
        conditionList: {
            type: String,
            default () {
                return '';
            }
        },
        columnList: {
            type: String,
            default () {
                return '';
            }
        }
    },
    methods: {
        dialogBeforeClose () {
            this.$emit('update:isShowAddLabel', false);
        },
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.btnLoading = true;
                const params = this.getParams(this.form);
                tabAdd(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('操作成功');
                        this.$emit('update:isShowAddLabel', false);
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            });
        },
        /**
         * @description 处理新建标签保存数据
         * @param {Object} data 表单数据
         */
        getParams (data) {
            data.labelType.map(v => {
                if (typeof JSON.parse(v) === 'object') {
                    data.conditionList = v;
                } else {
                    data.columnList = v;
                }
            });
            const params = {
                visualReportDefId: this.$route.path,
                tabName: data.tabName,
                conditionList: data.conditionList ? data.conditionList : '',
                columnList: data.columnList ? data.columnList : ''
            };
            for (const key in params) {
                if (params[key] === '') delete params[key];
            }
            return params;
        }
    }
};
</script>

<style lang="less">
.add-label-dialog-performance {
    .label-type {
        font-size: 14px;
        line-height: 40px;
    }
    .el-checkbox {
        display: block;
        text-align: left !important;
    }
    .el-form-item__label {
        font-size: 14px;
    }
}
</style>
